import { createContext, FC, useState } from 'react';
import { ListingProps } from '@/types/listing';
import { PropertyTabsContext } from './types';

const Context = createContext<PropertyTabsContext | undefined>(undefined);

export default Context;

export const PropertyTabsProvider: FC<Pick<ListingProps, 'listing'>> = ({
  children,
  listing,
}) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Context.Provider
      value={{
        tabIndex,
        setTabIndex,
        properties: listing.properties,
        tabCount: listing.properties.length,
      }}
    >
      {children}
    </Context.Provider>
  );
};
